<div class="ivd">
  @if (detail === null) {
    <!-- TODO: delete after clients have verifications -->
    <itfg-identity-documents-fallback
      [client]="client"
      [docList]="docList"
      [loading]="loadingDocList"
    />
  } @else {
    <div class="ivd__grid">
      @for (slot of slotViews; track slot.key) {
        <div class="ivd__col">
          <!-- Top bar: slot label + actions menu -->
          <div class="ivd__bar">
            <span class="s26-label">{{ slot.label }}</span>

            <input
              #fileInput
              type="file"
              accept="image/*"
              style="display: none"
              (change)="uploadDocument(slot.key, $event)"
            />

            <itfg-mat-tab-menu class="ivd__menu-btn">
              <div trigger>
                <mat-icon>more_horiz</mat-icon>
              </div>
              <div content>
                <button 
                  mat-menu-item 
                  (click)="fileInput.click()"
                  [disabled] = "!allowUpload(slot.key)"
                  >
                  <mat-icon>upload</mat-icon
                  ><span>{{
                    'verification.id.documentActions.upload' | translate
                  }}</span>
                </button>
                <button
                  mat-menu-item
                  [disabled]="!slot.documentId"
                  (click)="downloadDocument(slot.documentId, slot.key)"
                >
                  <mat-icon>download</mat-icon
                  ><span>{{
                    'verification.id.documentActions.download' | translate
                  }}</span>
                </button>
                <button
                  mat-menu-item
                  [disabled]="!slot.documentId"
                  (click)="rotateDocument(slot.documentId, slot.key, true)"
                >
                  <mat-icon>rotate_right</mat-icon
                  ><span>{{
                    'verification.id.documentActions.rotateClockwise'
                      | translate
                  }}</span>
                </button>
                <button
                  mat-menu-item
                  [disabled]="!slot.documentId"
                  (click)="rotateDocument(slot.documentId, slot.key, false)"
                >
                  <mat-icon>rotate_left</mat-icon
                  ><span>{{
                    'verification.id.documentActions.rotateCounterClockwise'
                      | translate
                  }}</span>
                </button>
                <button
                  mat-menu-item
                  [disabled]="!slot.documentId"
                  (click)="deleteDocument(slot.documentId, slot.key)"
                >
                  <mat-icon color="warn">delete</mat-icon
                  ><span class="ivd__action--danger">{{
                    'verification.id.documentActions.delete' | translate
                  }}</span>
                </button>
              </div>
            </itfg-mat-tab-menu>
          </div>

          <!-- Document viewer -->
          <div class="ivd__viewer-wrap">
            <itfg-identity-document-viewer
              [client]="client"
              [documentType]="SLOT_CONFIGS[slot.key].apiType"
              [selectedDocId]="slot.documentId"
              [docList]="docList"
              [loading]="loadingDocList || detail === undefined"
              [loadingList]="loadingDocList"
            >
            </itfg-identity-document-viewer>
          </div>

          <!-- Bottom bar: status chip + change state option -->
          <div class="ivd__bar">
            @let chipInteractive = slot.actionable && slot.canInvalidate;
            @if (detail !== undefined) {
              <mat-menu #changeDocStateMenu="matMenu" xPosition="after">
                <div class="s26-menu-header">
                  {{
                    'verification.id.documentActions.changeState.label'
                      | translate
                  }}
                </div>

                <!-- Приет - винаги най-отгоре, извън категориите -->
                <button
                  mat-menu-item
                  [disabled]="!chipInteractive"
                  (click)="
                    changeDocumentStatus(slot.key, DOCUMENT_STATE.ACCEPTED)
                  "
                >
                  <mat-icon>check_circle</mat-icon>
                  <span>{{
                    'verification.id.documentActions.changeState.' +
                      DOCUMENT_STATE.ACCEPTED | translate
                  }}</span>
                </button>

                <mat-divider></mat-divider>

                <!-- Категориите като nested submenus -->
                @for (category of INVALIDATION_CATEGORIES; track category.key) {
                  <itfg-identity-category-submenu
                    #submenu
                    [category]="category"
                    [disabled]="!chipInteractive"
                    (reasonSelected)="changeDocumentStatus(slot.key, $event)"
                  />
                  <button mat-menu-item [matMenuTriggerFor]="submenu.menu">
                    <span>{{
                      'verification.id.documentActions.changeState.categories.' +
                        category.key | translate
                    }}</span>
                  </button>
                }
              </mat-menu>

              <div
                class="s26-chip ivd__status-chip--{{ slot.stateClass }}"
                [class.s26-chip--actionable]="chipInteractive"
                [matMenuTriggerFor]="
                  chipInteractive ? changeDocStateMenu : null
                "
                [matTooltip]="chipInteractive ? 'Промени статуса' : null"
                matTooltipPosition="above"
              >
                {{ 'verification.id.documentState.' + slot.state | translate }}
                @if (chipInteractive) {
                  <mat-icon>arrow_drop_down</mat-icon>
                }
              </div>

              @if (slot.reason) {
                <div class="ivd__reason">
                  {{ slot.reasonLabel }}
                </div>
              }
            } @else {
              <div class="s26-skeleton s26-skeleton--text"></div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
